export enum Roles {
    USER = "ROLE_USER",
    ADMIN = "ROLE_ADMIN",
    OWNER = "ROLE_OWNER",
    CUSTOMER = "ROLE_CUSTOMER",
}